import NoDataComponent from 'components/NoDataComponent/NoDataComponent';
import { t } from 'i18next';
import { useState } from 'react';
import { Spinner } from 'reactstrap';
import { CommonFlex, CommonText } from 'styledComponents/common';

import AudioPlayer from '../TaskApproval/AudioPlayer';
import EvidencesModal from './EvidencesModal';
import { EvidenceThumbnail } from './taskDetailsStyles';

const TaskEvidence = ({ evidences }) => {
  const [popupOpen, setPopupOpen] = useState(false);
  const [selectedEvidence, setSelectedEvidence] = useState(false);

  const popupToggle = index => {
    setPopupOpen(!popupOpen);
    setSelectedEvidence(index);
  };
  return (
    <>
      <EvidencesModal
        isOpen={popupOpen}
        toggle={popupToggle}
        evidences={evidences?.filter(evidence => evidence.image)}
        selectedEvidence={selectedEvidence}
      />
      <CommonFlex gap="16px" direction="column" alignItems="start" width="100%">
        <CommonText name title fontSize="16px">
          {t('evidence')}
        </CommonText>
        {!evidences ? (
          <CommonFlex justifyContent={'center'} margin="auto">
            <Spinner size={25} />
          </CommonFlex>
        ) : (
          <>
            {evidences?.length > 0 ? (
              <div
                className="evidence-container"
                style={{
                  display: 'flex',
                  gap: '20px',
                  alignItems: 'start',
                  marginTop: '20px',
                }}
              >
                {evidences.map((evidence, index) => (
                  <div
                    key={index}
                  >
                    <CommonFlex
                      direction="column"
                      gap="8px"
                      style={{ marginBottom: '20px' }}
                    >
                      {evidence.evidence_type && (
                        <CommonText
                          name
                          title
                          fontSize="14px"
                          style={{ marginBottom: '10px' }}
                        >
                          {evidence.evidence_type === 'create'
                            ? t('requester')
                            : evidence.evidence_type === 'approve'
                              ? t('receiver')
                              : ''}
                        </CommonText>
                      )}
                      {evidence.image && (
                        <EvidenceThumbnail
                          width="auto"
                          onClick={() => popupToggle(index)}
                        >
                          <img
                            src={evidence.image}
                            alt=""
                            width="100%"
                            height={'100px'}
                          />
                        </EvidenceThumbnail>
                      )}
                      {evidence.audio && <AudioPlayer audio={evidence.audio} />}
                    </CommonFlex>
                    {evidence.note && (
                      <CommonText name fontSize="14px">
                        {t('note')}: {evidence.note}
                      </CommonText>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <CommonFlex width="100%" justifyContent="center">
                <NoDataComponent
                  title={t('no_evidence_found')}
                  padding="5vh 0"
                  imageHeight="140px"
                />
              </CommonFlex>
            )}
          </>
        )}
      </CommonFlex>
    </>
  );
};

export default TaskEvidence;
